<template>
  <div class="track-page">
    <div class="map-box" :style="{ height: h_map + 'px' }">
      <!--地图-->
      <e6-logistics-map
        ref="map"
        :mLevel.sync="mLevel"
        :aLevel.sync="aLevel"
        :mEyeShow.sync="mEyeShow"
        :aEyeShow.sync="aEyeShow"
        :isFullScreen.sync="isFullScreen"
        :categoryList.sync="categoryList"
        @init="mapInitBack_monitor"
        @exportExcel_pullRect="exportExcel_pullRect"
        @fullScreen="fullScreen"
        @showHide="hideMarkerEvent"
      ></e6-logistics-map>

      <!--查询面板-->
      <div v-loading="searchLoading" class="track-box tack-search-box">
        <div v-show="isSearchBoxExpend">
          <div class="box-item">
            <div class="label">选择车辆</div>
            <e6-select
              ref="vehicleTreeSelect"
              :dataList="vehicleTreeListData"
              :multiple="false"
              filterable
              issingleleaf
              slotTemplate="tree"
              widthData="235px"
              placeholder="选择车辆"
              @multipleSelect="treeSelectChanged"
            ></e6-select>
          </div>
          <div class="box-item">
            <div class="label">开始时间</div>
            <el-date-picker
              v-model="startTime"
              type="datetime"
              size="mini"
              :editable="false"
              :clearable="false"
              align="right"
              placeholder="选择日期时间"
              class="item-r datetime"
              value-format="timestamp"
            ></el-date-picker>
          </div>
          <div class="box-item">
            <div class="label">结束时间</div>
            <el-date-picker
              v-model="endTime"
              type="datetime"
              size="mini"
              :editable="false"
              :clearable="false"
              align="right"
              placeholder="选择日期时间"
              class="item-r datetime"
              value-format="timestamp"
            ></el-date-picker>
          </div>
          <div class="box-item">
            <div class="label">查询方式</div>
            <el-select
              v-model="searchType"
              size="mini"
              placeholder="请选择"
              class="item-r-m"
            >
              <el-option
                v-for="item in searchTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <el-select
              v-show="searchType == '2'"
              v-model="distanceSel"
              size="mini"
              placeholder="请选择"
              class="item-r-m"
            >
              <el-option
                v-for="item in distanceArr"
                :key="item"
                :label="item < 1 ? item * 1000 + 'm' : item + 'km'"
                :value="item"
              ></el-option>
            </el-select>

            <el-select
              v-show="searchType == '1'"
              v-model="timeSel"
              size="mini"
              placeholder="请选择"
              class="item-r-m"
            >
              <el-option
                v-for="item in timeArr"
                :key="item"
                :label="item < 1 ? item * 60 + '秒' : item + '分钟'"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="box-item">
            <div class="label">停车时长</div>
            <el-select
              v-model="searchStop"
              size="mini"
              placeholder="请选择"
              class="item-r"
            >
              <el-option
                v-for="item in searchStopArr"
                :key="item"
                :label="
                  item >= 60 ? '≥' + item / 60 + '小时' : '≥' + item + '分钟'
                "
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="box-item">
            <el-button
              @click="getTrack_click"
              class="search"
              type="primary"
              size="mini"
              icon="el-icon-search"
              >查询
            </el-button>
          </div>
        </div>
        <div
          class="close-box"
          v-show="!isSearchBoxExpend"
          :title="vehicle_label"
        >
          {{ vehicle_label }}
        </div>
        <i
          class="expend iconfont e6-icon-arrow-b_line iconfont_common mr5"
          :class="{ 'turn-around': !isSearchBoxExpend }"
          :title="isSearchBoxExpend ? '收起' : '展开'"
          @click="toggleSearchBox"
        ></i>
      </div>
      <!--回放控制面板-->
      <div class="track-box tack-control" v-show="isShowInfoBox">
        <i
          v-show="
            play_status == 'stop' || play_status == 'pause' || play_status == ''
          "
          class="e6-icon-play_fill1"
          :title="play_no == 0 ? '播放' : '继续播放'"
          @click="play_no == 0 ? play() : drawLine_play()"
        ></i>
        <i
          v-show="play_status == 'play'"
          class="e6-icon-pause_line"
          @click="pause"
          title="暂停"
        ></i>
        <i class="e6-icon-stop_fill1" @click="stop" title="停止"></i>
        <div class="process">
          <el-slider
            class="p"
            v-model="play_process"
            input-size="mini"
            :show-tooltip="false"
            style="width:70px;"
            disabled
          ></el-slider>
        </div>
        <span class="label">{{ play_process }}%</span>
        <!-- <div class="speed-sel">
                  <el-select v-model="play_speed" size="mini" placeholder="请选择" class="speed">
                    <el-option v-for="item in playSpeedArr" :key="item" :label="item+'X'" :value="item"></el-option>
                  </el-select>
                </div>-->
        <div class="speed_check">
          <ul>
            <li
              v-for="item in playSpeedArr"
              :class="{ 'is-check': item == play_speed }"
              :key="item"
              :data-speed="item"
              :title="item + '倍速'"
              @click="checkSpeed"
            >
              {{ item }}X
            </li>
          </ul>
        </div>
        <!--<i-->
        <!--  class="e6-icon-save_line"-->
        <!--  title="保存线路"-->
        <!--  @click="saveLineClick"-->
        <!--&gt;</i>-->
        <i
          class="e6-icon-export_line"
          title="导出轨迹"
          @click="exportLineClick"
          v-if="operationSuper.导出"
        ></i>
        <i
          class="e6-icon-track_line"
          title="清除轨迹"
          @click="clearLineClick"
        ></i>
      </div>

      <!--右上角展示面板-->
      <div class="track-box track-info" v-show="isShowInfoBox">
        <h4 v-drag style="margin: 0; height: 20px;">
          <i
            class="expend iconfont e6-icon-arrow-b_line"
            :class="{ 'turn-around': isInfoBoxExpend }"
            :title="isInfoBoxExpend ? '收起' : '展开'"
            @click="toggleInfoBox"
          ></i>
        </h4>
        <!--<div class="info-item" v-show="isInfoBoxExpend">-->
        <!--  <div class="title">图标设置：</div>-->
        <!--  <div>-->
        <!--    <img-->
        <!--      v-for="(item, index) in iconStatus"-->
        <!--      :key="index"-->
        <!--      v-show="statusIconShow(item)"-->
        <!--      :src="-->
        <!--        'e6Images/' + item.icon + (item.isShow ? 's' : 'grey') + '.png'-->
        <!--      "-->
        <!--      :title="item.title + '，点击' + (item.isShow ? '隐藏' : '显示')"-->
        <!--      @click="iconClick(item)"-->
        <!--    />-->
        <!--  </div>-->
        <!--</div>-->
        <div class="info-item" v-show="isInfoBoxExpend">
          <div class="title">播放设置：</div>
          <div>
            <ul>
              <li
                v-for="(item, index) in trackStatus"
                :key="index"
                :class="{ isChecked: item.ischecked }"
                @click="statusItemClick(item)"
              >
                <i class="el-icon-view"></i>
                <a href="javascript:void(0)">{{ item.name }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="info-bottom"
          :style="{ 'margin-top': isInfoBoxExpend ? '30px' : 0 }"
        >
          <div class="weight">
            <div>总里程：</div>
            <span>{{ odometer_all }}km</span>
          </div>
          <el-checkbox
            size="mini"
            v-show="isInfoBoxExpend"
            class="saveTrack"
            v-model="saveTrack"
            title="最多3条"
            >保留轨迹
          </el-checkbox>
        </div>
      </div>
    </div>

    <!--列表-->
    <div class="track-list" v-loading="tableLoading">
      <e6-resizer :top="h_map" @move="resizerMove" :min="38"></e6-resizer>
      <div class="list-tab clearfloat">
        <div class="fl">
          <e6Tab :tabList="statTabList" @tabChange="statTabChange"></e6Tab>
        </div>
        <div class="fr">
          <i
            class="iconfont e6-icon-window-window_line iconfont_common mr5"
            :class="[
              !trackTableShow
                ? 'e6-icon-window-window_line'
                : 'e6-icon-minus_line'
            ]"
            :title="!trackTableShow ? '窗口化' : '最小化'"
            @click="showOrHideTable(false)"
          ></i>
        </div>
      </div>
      <div class="list-line"></div>
      <div
        class="table-div"
        v-show="trackTableShow"
        :style="{ height: table_height_cal + 'px' }"
      >
        <!--轨迹点列表-->
        <el-bigdata-table
          v-show="cur_tab == '轨迹点'"
          highlight-current-row
          ref="tracktable"
          :data="trackTableData"
          :height="table_height_cal"
          :row-height="26"
          @row-click="trackTableClick"
          stripe
          border
          empty-text=" "
          style="width: 100%"
        >
          <el-table-column
            align="center"
            label="序号"
            header-align="center"
            type="index"
            width="55"
          ></el-table-column>
          <el-table-column
            property="vehicleNo"
            label="车牌号"
            header-align="center"
            width="150"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            property="companyName"
            label="所属企业"
            header-align="center"
            width="150"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            property="gpsTime"
            label="定位时间"
            header-align="center"
            width="150"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            property="speed"
            label="速度"
            header-align="center"
            align="right"
            width="80"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            property="odometer"
            label="里程"
            header-align="center"
            align="right"
            width="100"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            property="curOdom"
            label="行驶里程"
            width="100"
            align="right"
            header-align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            property="status"
            label="状态"
            header-align="center"
            width="180"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            property="trackPlace"
            label="位置"
            header-align="center"
            width="300"
            :formatter="getTrackPlace"
            :show-overflow-tooltip="true"
          ></el-table-column>

          <el-table-column
            property="lon"
            label="经度"
            width="100"
            header-align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            property="lat"
            label="纬度"
            width="100"
            header-align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
        </el-bigdata-table>
        <div
          v-show="cur_tab == '温度'"
          ref="temperatureChartDOM"
          style="width: 100%; height: 100%"
          :class="{ chartNoData: temperatureNoData }"
          :style="{ height: table_height_cal + 'px' }"
        ></div>
        <div
          v-show="cur_tab == '湿度'"
          ref="humidityChartDOM"
          style="width: 100%; height: 100%"
          :class="{ chartNoData: humidityNoData }"
          :style="{ height: table_height_cal + 'px' }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
// style
import "@/assets/css/map/e6_common.scss";
import "@/assets/css/map/track.scss";

// plugin
import "swiper/dist/css/swiper.min.css";
import moment from "moment";
import ECharts from "echarts";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";

// components
import e6Tab from "@/components/e6Tab";
import e6LogisticsMap from "@/components/e6LogisticsMap";
import elBigdataTable from "@/components/vue-element-bigdata-table";
import e6Resizer from "@/components/resizer";

// mixins
import { mixin } from "@/mixins/logisOverlaysHandle.js";
import operationManage from "_private/mixins/operationManage";

// methods
import { getPageSize } from "@/utils/map/e6Common.js";

// interface
import api from "@/api/monitorCenter/track.js";
import { deepEqual } from "assert";
import { FetchVehicleTree } from "@/api/base/vehicle";

export default {
  name: "tracker",
  mixins: [mixin, operationManage],
  components: {
    e6LogisticsMap,
    e6Tab,
    e6Resizer,
    elBigdataTable
  },
  data() {
    return {
      tableLoading: false,
      trackTableShow: false,
      FRAME_TOP_HEIGHT: 53,
      TRACK_TABLE_HEIGHT: 200, // 固定的表格高度
      table_height_cal: 0, // 计算的表格高度  可能会因为拖拽影响
      TAB_HEIGHT: 41,
      h_map: 0,
      mapName: "map",
      mLevel: "市",
      aLevel: "市",
      // 是否查询面板打开
      isSearchBoxExpend: true,
      isInfoBoxExpend: false,
      isShowInfoBox: false,

      isPhotoDialogVisible: false, // 是否显示照片预览
      currenPhoto: { url: "", data: {} },

      searchLoading: false, // 加载中

      // 播放状态
      play_status: "", // "play" "pause" "stop"
      // 速度控制
      playSpeedArr: [1, 2, 4, 8, 16, 32],
      play_speed: 2,
      // 默认的播放间隔
      play_default_second: 1000,
      // 播放进度
      play_process: 0,
      // 播放序号
      play_no: 0,
      // 播放数组序号
      play_data_no: 0,
      // 播放过程当前动态点
      play_point: {},
      playTimeOut: null, // 播放循环
      // 车辆选择
      vehicle_list: [],
      vehicle_sel: "",
      vehicle_label: "",
      // 时间选择
      startTime: "",
      endTime: "",
      // 查询方式
      searchTypeList: [
        { label: "间距", value: 2 },
        { label: "时间间隔", value: 1 }
      ],
      searchType: 2,
      distanceArr: [0.01, 0.1, 0.5, 1, 3, 5, 10, 30, 50], // km 为单位
      distanceSel: 3,
      timeArr: [1 / 6, 1 / 2, 1, 3, 5, 10, 30, 60], // 秒为单位
      timeSel: 3,
      // 查询 停车时长选择
      searchStopArr: [3, 5, 10, 30, 60], // 分钟为单位
      searchStop: 3,
      // 多条线颜色
      multip_color: ["#00BD00", "#13B4EB", "#F159F9"],
      // 图标设置
      iconStatus: [
        { title: "停车", isShow: true, icon: "p_stop_" },
        { title: "闪拍", isShow: true, icon: "p_flashPhoto_" },
        { title: "主动安全", isShow: true, icon: "p_activeSafe_" }
      ],

      saveTrack: false, // 保留轨迹（最多3条）
      saveLines: [], // 保存保留的轨迹数据
      trackStatus: [
        { name: "日期", code: "date", ischecked: false },
        { name: "时间", code: "time", ischecked: false },
        { name: "里程", code: "odo", ischecked: false },
        { name: "速度", code: "speed", ischecked: false },
        { name: "途经点", code: "pass", ischecked: false }
        // { name: "停车时长", code: "stop", ischecked: false }
      ],
      trackStatusArr: [], //  播放时判断的  播放状态控制

      // tab 切换
      cur_tab: "轨迹点", // track stop speed area
      statTabList: [
        {
          type: "轨迹点",
          isActive: true,
          selected: { name: "轨迹点", num: 0 }
        },
        {
          type: "温度",
          isActive: false,
          selected: { name: "温度" }
        },
        {
          type: "湿度",
          isActive: false,
          selected: { name: "湿度" }
        }
      ],

      PAGESIZE_LINE: 5000,
      cur_page_line: 1,
      trackListData: [], // 轨迹线数据

      PAGESIZE_TABLE: 1000,
      cur_page_table_track: 1, // 轨迹点列表当前页
      trackTableData: [], // 轨迹列表数据

      odometer_all: 0, //  总里程

      trackLines: [], // 轨迹线对象数组
      s_epoint: [], // 起终点 对象数组

      pass_point: [], // 途经点

      cacheClickObj: null, // 点击后显示的对象 点 、线 、面

      // 温度曲线图表实例
      tempChart: null,
      temperatureData: [],
      temperatureNoData: true,
      // 湿度曲线图表实例
      humidityChart: null,
      humidityData: [],
      humidityNoData: true,

      categoryList: [],
      vehicleTreeListData: [],
      // 区域数据
      areaDatas: [], // 普通区域
      xzAreaDatas: [], //行政区域，
      areaMapObj: [],
      areaCenterMapObj: []
    };
  },
  mounted() {
    this.pageResize();
    window.addEventListener("resize", this.pageResize);
    this.initPage(this.$route.query);
  },
  watch: {
    isFullScreen: function() {
      this.pageResize();
    },
    table_height_cal: function() {
      this.pageResize();
    }
  },
  computed: {
    // 是否显示停车点
    isShowStopMarker() {
      return this.iconStatus.some(i => {
        return i.title == "停车" && i.isShow;
      });
    },
    // 是否显示 闪拍点
    isShowPhotoMarker() {
      return this.iconStatus.some(i => {
        return i.title == "闪拍" && i.isShow;
      });
    },
    // 是否显示 主动安全 点
    isShowSecurityMarker() {
      return this.iconStatus.some(i => {
        return i.title == "主动安全" && i.isShow;
      });
    },
    // 当前显示的报警类型
    curAlarmTab() {
      var alarm = this.statTabList.find(s => s.type == "报警");
      return alarm.selected.typeId || 0;
    },
    // 当前显示的事件类型
    curSecurityTab() {
      var alarm = this.statTabList.find(s => s.type == "主动安全事件");
      return alarm.selected.typeId || 0;
    }
  },
  filters: {
    // 报警表格过滤器
    alarmTableFilter: function(list, type) {
      if (type != "" && type != 0) {
        var typeId = type.split("-");
        var l = list.filter(v => {
          return (
            v.firstAlarmType == typeId[0] && v.secondAlarmType == typeId[1]
          );
        });
        return l;
      } else {
        return list;
      }
    },
    // 主动安全表格过滤器
    securityTableFilter: function(list, type) {
      if (type != "" && type != 0) {
        var l = list.filter(v => {
          return v.eventType == type;
        });
        return l;
      } else {
        return list;
      }
    }
  },
  methods: {
    initPage({ vId = 0, sTime, eTime }) {
      this.$nextTick(() => {
        this.initOptions();
        this.vehicle_sel = vId ? vId : "";
        let stime = 0,
          etime = 0;
        if (sTime) {
          stime = moment(new Date(sTime));
        } else {
          stime = moment()
            .hour("00")
            .minute("00")
            .second("00");
        }
        if (eTime) {
          etime = moment(new Date(eTime));
        } else {
          etime = moment()
            .hour("23")
            .minute("59")
            .second("59");
        }
        this.startTime = stime.format("x");
        this.endTime = etime.format("x");
        // 监控页面跳转过来，传单车轨迹，默认直接查询
        //this.requestVehicleList();
        this.initVehicleTree();

        if (this.vehicle_sel) {
          this.getTrack_click();
        }
      });
    },
    mapInitBack_monitor() {
      // 请求区域数据
      this.fetchAreaDatas("map");
    },
    // 页面跳转，处理默认参数
    initOptions() {
      this.vehicle_list = [];
      this.vehicle_sel = [];
      this.vehicle_label = "";
      this.startTime = "";
      this.endTime = "";
      this.isSearchBoxExpend = true;
      this.isInfoBoxExpend = true;
      this.isShowInfoBox = false;
      this.play_speed = 2;
      this.saveTrack = false;
      this.trackTableShow = false;
      this.clearVaribles();
    },
    // 清除已查询出来的数据
    clearVaribles() {
      this.odometer_all = 0;
      this.play_status = "stop";
      this.play_process = 0;
      this.play_no = 0;
      this.play_data_no = 0;
      this.play_point = {};
      this.playTimeOut = null;
      this.trackListData = [];
      this.trackTableData = [];
      this.pass_point = [];
      this.s_epoint = [];
      this.cur_page_table_track = 1; // 轨迹点列表当前页
      this.cur_page_line = 1;
      this.temperatureData = [];
      this.humidityData = [];
      this.tempChart && this.tempChart.clear();
      this.humidityChart && this.humidityChart.clear();
      this.setTabNum();
    },
    /**
     * 显示/隐藏 查询面板
     */
    toggleSearchBox() {
      this.isSearchBoxExpend = !this.isSearchBoxExpend;
    },
    // 显示/隐藏 轨迹信息展示  右上角 面板
    toggleInfoBox() {
      this.isInfoBoxExpend = !this.isInfoBoxExpend;
    },
    /**
     * 显示/隐藏表格
     * isShow 是否要保持显示
     */
    showOrHideTable(isShow = false) {
      if (isShow && this.trackTableShow) {
        return;
      } else {
        this.trackTableShow = !isShow ? !this.trackTableShow : isShow;
        if (this.trackTableShow) {
          this.table_height_cal = this.TRACK_TABLE_HEIGHT;
        } else {
          this.table_height_cal = 0;
        }
        this.pageResize();
      }
    },
    // 设置图标是否显示
    statusIconShow(icon) {
      let isShow = false;
      switch (icon.title) {
        // case "停车":
        //   isShow = this.stopTableData.length > 0;
        //   break;
        // case "闪拍":
        //   isShow = this.photoTableData.length > 0;
        //   break;
        // case "开关门":
        //   isShow = this.openDoorTableData.length > 0;
        //   break;
        // case "施封":
        //   isShow = this.lockTableData.length > 0;
        //   break;
        // case "解封":
        //   isShow = this.unLockTableData.length > 0;
        //   break;
        // case "卸灰":
        //   isShow = this.unloadTableData.length > 0;
        //   break;
        // case "主动安全":
        //   isShow = this.securityTableData.length > 0;
        //   break;
        default:
          break;
      }
      return isShow;
    },
    // 图标设置 点击事件
    iconClick(icon) {
      this.iconStatus.some(i => {
        if (i.title == icon.title) {
          i.isShow = !i.isShow;
          this.showOrHideMarkers(i);
          return true;
        }
      });
    },
    // 图标点击  处理  markers 的显示隐藏
    showOrHideMarkers(icon) {
      let markerArr = [];
      if (icon.isShow) {
        this.$refs.map.mapAPI.addOverlay(markerArr);
      } else {
        this.$refs.map.mapAPI.removeOverlay(markerArr);
      }
    },
    // 播放控制 元素 点击事件
    statusItemClick(item) {
      let code = JSON.parse(JSON.stringify(this.trackStatusArr));
      if (item.ischecked) {
        let index = code.indexOf(item.code);
        if (index > -1) {
          code.splice(index, 1);
        }
      } else {
        // 点击途经点
        if (item.code == "pass") {
          code = ["pass", "time", "speed", ...code];
        } else {
          code.push(item.code);
        }
      }
      if (item.code == "stop") {
        // 勾选停车时间， 需展示/隐藏停车点的停车时长显示
        this.showOrHideStopTime(!item.ischecked);
      }
      this.trackStatusArr = [];
      this.trackStatus.forEach(s => {
        if (code.includes(s.code)) {
          s.ischecked = true;
          this.trackStatusArr.push(s.code);
        } else {
          s.ischecked = false;
        }
      });
    },
    // 显示 / 隐藏 停车点的停车时长
    showOrHideStopTime(isShow) {
      this.stopMarkers.forEach(m => {
        this.$refs.map.mapAPI.setLabel(m, isShow ? m.myLabel : null);
      });
    },
    // 列表tab切换
    statTabChange(opts) {
      this.showOrHideTable(true);
      this.statTabList.forEach(item => {
        if (item.type == opts.type) {
          item.isActive = true;
          item.selected = JSON.parse(JSON.stringify(opts.selected));
          this.cur_tab = item.type; //  记录当前tab
        } else {
          item.isActive = false;
        }
      });
      this.chartsResize();
    },
    /**
     * 页面变化计算地图高度
     */
    pageResize() {
      this.h_map =
        document.querySelector(".track-page").clientHeight -
        document.querySelector(".resizer-drag").clientHeight -
        document.querySelector(".list-tab").clientHeight -
        this.table_height_cal;

      this.chartsResize();
      this.$nextTick(() => {
        this.$refs.map.resize();
      });
    },
    // 拖动回调
    resizerMove(top) {
      this.trackTableShow = true;
      this.table_height_cal =
        document.querySelector(".track-page").clientHeight -
        top -
        document.querySelector(".resizer-drag").clientHeight -
        document.querySelector(".list-tab").clientHeight;
      if (top < 300) {
        this.isSearchBoxExpend = false;
        this.isInfoBoxExpend = false;
      }
      this.chartsResize();
    },
    // tab 数据初始化
    setTabNum() {
      this.statTabList.forEach(tab => {
        switch (tab.type) {
          case "轨迹点":
            tab.selected.num = this.trackTableData.length;
            break;
          case "停车":
            tab.selected.num = this.stopTableData.length;
            break;
          case "区域":
            tab.selected.num = this.areaTableData.length;
            break;
          case "报警":
            tab.selected.num = this.alarmTableData.length;
            tab.children = this.alarmCountData;
            break;
          case "闪拍":
            tab.selected.num = this.photoTableData.length;
            tab.children = this.photoCountData;
            break;
          case "主动安全事件":
            tab.selected.num = this.securityTableData.length;
            tab.children = this.securityCountData;
            break;
          default:
            break;
        }
      });
    },
    // // 获取车辆选择列表数据
    // requestVehicleList() {
    //     return api
    //         .fetchVehicleList()
    //         .then(res => {
    //             if (res.code == 1) {
    //                 this.vehicle_list = res.result;
    //             }
    //         })
    //         .catch(e => {
    //             console.log(e);
    //             console.log("获取车辆列表错误");
    //         });
    // },
    //获取车辆数
    initVehicleTree() {
      FetchVehicleTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.vehicleTreeListData = response.result;
            this.$nextTick(() => {
              this.$refs.vehicleTreeSelect.setSelectList(this.vehicle_sel);
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    treeSelectChanged(nodes) {
      let selected = nodes.map(node => node.id);
      this.vehicle_sel = selected[0];
    },
    // 查询轨迹按钮 点击方法
    getTrack_click() {
      if (!this.vehicle_sel) {
        this.$message({
          showClose: true,
          message: "请选择车辆",
          type: "error"
        });
        return;
      }
      let stime = moment(parseInt(this.startTime));
      let etime = moment(parseInt(this.endTime));
      if (stime.diff(etime) >= 0) {
        this.$message({
          showClose: true,
          message: "请保证:开始时间 < 结束时间",
          type: "error"
        });
        return;
      }
      if (etime.diff(stime) > 1e3 * 60 * 60 * 24 * 7) {
        this.$message({
          showClose: true,
          message: "最多查询7天的轨迹数据",
          type: "error"
        });
        return;
      }
      this.getVehicleTrack();
    },
    // 请求轨迹数据
    async getVehicleTrack() {
      this.clearAllOverlay("search");
      this.clearVaribles();
      this.searchLoading = true;
      this.play_status = "";
      this.play_no = 0;
      clearTimeout(this.playTimeOut);
      this.play_point.length > 0 &&
        this.$refs.map.mapAPI.removeOverlay(this.play_point);
      this.vehicle_label = "";
      let vehicle = this.vehicle_list.find(v => {
        return v.vehicleId == this.vehicle_sel;
      });
      if (vehicle) {
        this.vehicle_label = vehicle.vehicleNo;
      }
      await this.requestTrack();
      this.searchLoading = false;
      if (this.trackListData.length > 0) {
        this.isInfoBoxExpend = true; // 打开右上角信息框
        this.isShowInfoBox = true;
        /**
         * 存在轨迹数据
         * 1、画线
         * 2、请求列表数据
         * 3、请求停车 等 数据，
         * 4、在地图画点；
         */
        this.drawLine();
        this.cur_page_table_track = 1;
        this.requestTrackTableList();
        this.fetchTemperatureList();
        this.fetchHumidityList();
      }
    },
    // 请求轨迹
    async requestTrack() {
      await api
        .fetchTrackList({
          pageParamVO: {
            pageSize: this.PAGESIZE_LINE,
            curPage: this.cur_page_line
          },
          vehicleid: this.vehicle_sel,
          startTime: this.startTime,
          endTime: this.endTime
        })
        .then(res => {
          if (res.code == 1) {
            let oData = res.result;
            let list = oData.data;
            if (list.length == 0) {
              let vehicle = this.vehicle_list.find(v => {
                return v.vehicleId == this.vehicle_sel;
              });
              this.$message({
                showClose: true,
                message: `${vehicle ? vehicle.vehicleNo : ""}无轨迹数据`,
                type: "error"
              });
              return;
            } else {
              // 分页处理
              this.trackListData = this.trackListData.concat(list);
              if (this.trackListData.length < oData.totalRecords) {
                this.cur_page_track++;
                this.requestTrack();
              }
            }
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.searchLoading = false;
        });
    },
    // 请求轨迹列表数据
    requestTrackTableList() {
      this.tableLoading = true;
      api
        .fetchTrackTableList({
          pageParamVO: {
            pageSize: this.PAGESIZE_TABLE,
            curPage: this.cur_page_table_track
          },
          vehicleId: this.vehicle_sel,
          startTime: this.startTime,
          endTime: this.endTime,
          distance: this.searchType == 1 ? null : this.distanceSel * 1000,
          second: this.searchType == 2 ? null : this.timeSel * 60,
          stopSecond: this.searchStop
        })
        .then(res => {
          if (res.code == 1) {
            let oData = res.result;
            let list = oData.data;
            this.trackTableData = this.trackTableData.concat(list);
            this.setTabNum();
            if (this.trackTableData.length < oData.totalRecords) {
              this.cur_page_table_track++;
              this.requestTrackTableList();
            } else {
              this.setTabNum();
              this.tableLoading = false;
              // this.$refs.tracktable.doLayout();
            }
            /*** 解决当数据量大表格重新加载时出现空白的问题 start ***/
            const scrollParent = this.$refs.tracktable.$el.querySelector(
              ".el-table__body-wrapper"
            );
            scrollParent.scrollTop = 0; // 表格滚动区域 scrollTop 值设置为 0
            this.$refs.tracktable.groupIndex = 0; // 表格的groupIndex = 0
            this.$refs.tracktable.currentIndex = 0; // 表格的currentIndex = 0
            /*** 解决当数据量大表格重新加载时出现空白的问题 end ***/
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error"
            });
          }
        });
    },
    // 异步更新 轨迹点 表格的 地理位置信息
    getTrackPlace(row, column, cellValue) {
      if (row.trackPlace != "" || !this.trackTableShow) {
        return cellValue;
      } else {
        row.trackPlace = "加载中...";
        api
          .fetchPositionByLonLat({
            lon: row.lon,
            lat: row.lat
          })
          .then(res => {
            if (res.code == 1) {
              // 给 “ ” 的原因是，防止死循环
              row.trackPlace = res.result == "" ? " " : res.result;
            } else {
              row.trackPlace = "加载失败";
            }
          });
        return cellValue;
      }
    },
    // 画线
    drawLine() {
      let pointArr = [];
      this.trackListData.forEach(m => {
        if (m.lat !== 0 && m.lon != 0) {
          let lngLatObj = this.$refs.map.mapAPI.createLngLat({
            lng84: m.lon,
            lat84: m.lat
          });
          pointArr.push(lngLatObj);
        }
      });
      let trackLine = this.$refs.map.mapAPI.createLine({
        path: pointArr,
        strokeColor: this.multip_color[0],
        strokeOpacity: 1,
        strokeWeight: 8,
        strokeStyle: "solid",
        showDir: true
      });
      this.trackLines.push(trackLine);
      this.$refs.map.mapAPI.addOverlay(trackLine);

      this.drawTrackStartPoint("line");
      this.drawTrackEndPoint("line");

      this.$refs.map.mapAPI.setFitView({ overlayList: this.trackLines });
    },
    // 画 轨迹起点
    drawTrackStartPoint(opr) {
      let data = [];
      if (opr == "line") {
        data = JSON.parse(JSON.stringify(this.trackListData));
      } else {
        data = JSON.parse(JSON.stringify(this.trackTableData));
      }
      let slnglat = this.$refs.map.mapAPI.createLngLat({
        lng84: data[0].lon,
        lat84: data[0].lat
      });
      let spoint = {
        llObj: { lng02: slnglat.lng, lat02: slnglat.lat },
        icon: `e6Images/start.png`,
        label: ""
      };

      let markers = this.$refs.map.createMarkers([spoint]);
      this.s_epoint.push(markers[0]);
      this.$refs.map.mapAPI.addOverlay(markers[0]);
    },
    // 画 轨迹  终点
    drawTrackEndPoint(opr) {
      let data = [];
      if (opr == "line") {
        data = JSON.parse(JSON.stringify(this.trackListData));
      } else {
        data = JSON.parse(JSON.stringify(this.trackTableData));
      }
      let elnglat = this.$refs.map.mapAPI.createLngLat({
        lng84: data[data.length - 1].lon,
        lat84: data[data.length - 1].lat
      });
      let odometer = (
        data[data.length - 1].odometer - data[0].odometer
      ).toFixed(1);
      let epoint = {
        llObj: { lng02: elnglat.lng, lat02: elnglat.lat },
        icon: `e6Images/end.png`,
        label: "总里程：" + isNaN(odometer) ? 0 : odometer + "km"
      };
      this.odometer_all = isNaN(odometer) ? 0 : odometer;

      let markers = this.$refs.map.createMarkers([epoint]);
      this.s_epoint.push(markers[0]);
      this.$refs.map.mapAPI.addOverlay(markers[0]);
    },

    // 轨迹点列表 点击事件
    trackTableClick(row) {
      this.dealClickPoint({ row: row, icon: "e6Images/bg_cluster.png" });
    },
    //  处理点击事件 通用方法
    dealClickPoint({ row, icon, title, isShowWin = false }) {
      this.cacheClickObj &&
        this.$refs.map.mapAPI.removeOverlay(this.cacheClickObj); // 移除上一个点
      let lnglat = this.$refs.map.mapAPI.createLngLat({
        lng84: row.lon,
        lat84: row.lat
      });
      let point = {
        llObj: { lng02: lnglat.lng, lat02: lnglat.lat },
        icon: icon
      };
      let marker = this.$refs.map.createMarkers([point]); // 创建点
      this.$refs.map.mapAPI.addOverlay(marker[0]); // 添加点到地图
      this.setPlayPointInWin(lnglat); // 设置中心点到该点
      this.cacheClickObj = marker[0]; // 存储点
      isShowWin && this.showLabelWindow(row, title);
    },
    ///  对需要清除的操作进行区分，进行分别处理
    clearAllOverlay(opr) {
      this.s_epoint.length > 0 &&
        this.$refs.map.mapAPI.removeOverlay(this.s_epoint);
      this.play_point.length > 0 &&
        this.$refs.map.mapAPI.removeOverlay(this.play_point);
      this.pass_point.length > 0 &&
        this.$refs.map.mapAPI.removeOverlay(this.pass_point);
      this.cacheClickObj &&
        this.$refs.map.mapAPI.removeOverlay(this.cacheClickObj);
      this.s_epoint = [];
      this.play_point = [];
      this.pass_point = [];
      this.stopMarkers = [];
      this.cacheClickObj = null;
      //  查询，需判断是否保留轨迹，如果不保留，则清除所有轨迹
      if (opr == "search") {
        if (!this.saveTrack) {
          this.removeAllLines();
        } else {
          this.multip_color.push(this.multip_color.splice(0, 1));
          if (this.trackLines.length == 3) {
            this.$message({
              showClose: true,
              message: "最多保留3条，系统将自动删除最早一条轨迹",
              type: "warning"
            });
            this.$refs.map.mapAPI.removeOverlay(this.trackLines.shift());
          }
        }
      }
      //  播放，只需清除掉 trackLines 数组中，最后一条轨迹，前面的数据可能是保留的轨迹数据
      else if (opr == "play") {
        this.$refs.map.mapAPI.removeOverlay(this.trackLines.pop());
      }
      //  清除，清除全部数据即可
      else if (opr == "clear") {
        this.removeAllLines();
      }
    },
    // 移除所有的 线
    removeAllLines() {
      this.trackLines.length > 0 &&
        this.$refs.map.mapAPI.removeOverlay(this.trackLines);
      this.trackLines = [];
      this.multip_color = ["#00BD00", "#13B4EB", "#F159F9"];
    },
    // 播放
    play() {
      this.play_no = 0;
      this.play_data_no = 0;
      this.play_process = 0;
      this.isSearchBoxExpend = false;
      // // 先清楚所有 叠加物
      this.clearAllOverlay("play");
      // // 画线
      this.drawLine_play();
    },
    // 暂停播放
    pause() {
      this.play_status = "pause";
      clearTimeout(this.playTimeOut);
    },
    // 速度选择
    checkSpeed(e) {
      let speed = e.target.dataset.speed;
      this.play_speed = speed;
    },
    // 停止播放
    stop() {
      this.play_status = "stop";
      this.play_no = 0;
      clearTimeout(this.playTimeOut);
      // this.play_point.length > 0 &&
      //   this.$refs.map.mapAPI.removeOverlay(this.play_point);
    },
    // 播放轨迹画线
    drawLine_play() {
      let playData = this.trackTableData; // this.trackListData;
      if (playData.length == 0) {
        this.$message({
          showClose: true,
          message: "请先查询轨迹",
          type: "warning"
        });
        return;
      }
      this.play_status = "play";
      let obj = playData[this.play_no];
      this.lastObj = playData[this.play_no == 0 ? 0 : this.play_no - 1];
      this.play_no == 0 && this.drawTrackStartPoint();
      // 画整段线
      this.addLine_play(playData.slice(0, this.play_no + 1));
      // 分段画线   实践发现会影响效率
      // this.addLine_play([this.lastObj, obj]);
      // 画回放点
      this.drawPlayPoint(obj);
      // 将打开的表格滚动到当前回放的时间点对应的数据行
      this.setTableLineIntoView(
        obj,
        playData[
          this.play_no == playData.length - 1 ? this.play_no : this.play_no + 1
        ]
      );
      this.play_no++;
      if (this.play_no == playData.length) {
        // 画终点
        this.drawTrackEndPoint();
        this.play_process = 100;
        this.stop();
        this.$message({
          showClose: true,
          message: "回放完成",
          type: "success"
        });
      } else {
        this.play_process = parseInt((this.play_no * 100) / playData.length);
        if (this.play_status == "play") {
          this.playTimeOut = setTimeout(
            this.drawLine_play,
            this.play_default_second / this.play_speed
          );
        }
      }
    },
    // 设置表格跟随滚动
    setTableLineIntoView(obj, next) {
      if (!this.trackTableShow) return;
      switch (this.cur_tab) {
        case "轨迹点":
          this.setTrackTableIntoView(obj, next);
          break;
      }
    },
    // 设置轨迹表格滚动
    setTrackTableIntoView(obj) {
      this.trackTableData.forEach((m, i) => {
        if (
          moment(new Date(m.gpsTime)).diff(moment(new Date(obj.gpsTime))) == 0
        ) {
          this.setCurrentRow(i, this.$refs.tracktable, this.trackTableData);
        }
      });
    },
    // 设置滚动
    setCurrentRow(i, ref, data) {
      try {
        ref.setCurrentRow(data[i]);
        this.$nextTick(() => {
          const scrollParent = ref.$el.querySelector(".el-table__body-wrapper");
          scrollParent.scrollTop = 26 * i;
        });
      } catch (e) {
        console.log(e);
      }
    },
    // 播放画线
    addLine_play(data) {
      // 此处判断是否开始播放起点， 如果是，则不用清除数据，如果不是，则清除 trackLines 中最后一条轨迹，因为前面有可能是保留的轨迹数据
      if (this.trackLines.length > 0 && this.play_no > 0) {
        this.$refs.map.mapAPI.removeOverlay(this.trackLines.pop());
      }
      let pointArr = data.map(m => {
        return this.$refs.map.mapAPI.createLngLat({
          lng84: m.lon,
          lat84: m.lat
        });
      });
      let trackLine = this.$refs.map.mapAPI.createLine({
        path: pointArr,
        strokeColor: this.multip_color[0],
        strokeOpacity: 1,
        strokeWeight: 8,
        strokeStyle: "solid",
        showDir: true
      });
      this.trackLines.push(trackLine);
      this.$refs.map.mapAPI.addOverlay(trackLine);
    },
    // 播放过程 画领头点
    drawPlayPoint(point) {
      let lnglat = this.$refs.map.mapAPI.createLngLat({
        lng84: point.lon,
        lat84: point.lat
      });

      let iconPath =
        "e6Images/loCars/car/run_" +
        (Math.round(Number(point.direction) / 45) % 8) +
        ".png";

      let play_point = {
        llObj: { lng02: lnglat.lng, lat02: lnglat.lat },
        width: 32,
        height: 32,
        // icon: `e6Images/center.png`,
        icon: iconPath,
        label: this.getPlayPointTitle(point),
        offsetType: 0
        // angle: point.direction
      };
      this.setPlayPointInWin(lnglat);
      let markers = this.$refs.map.createMarkers([play_point]);
      this.$refs.map.mapAPI.addOverlay(markers[0]);
      if (this.trackStatusArr.includes("pass")) {
        this.pass_point.push(markers[0]);
      } else {
        this.play_point.length > 0 &&
          this.$refs.map.mapAPI.removeOverlay(this.play_point);
      }
      this.play_point = [markers[0]];
    },
    // 根据 用户配置 获取领头点 的 title 显示
    getPlayPointTitle(point) {
      var title = "";
      if (this.trackStatusArr.includes("date")) {
        title += point.gpsTime.split(" ")[0] + " ";
      }
      if (this.trackStatusArr.includes("time")) {
        title += point.gpsTime.split(" ")[1] + " ";
      }
      if (this.trackStatusArr.includes("odo")) {
        title += point.odometer + "km ";
      }
      if (this.trackStatusArr.includes("speed")) {
        title += point.speed + "km/h";
      }
      return title;
    },
    // 设置回放 领头点在可是范围内
    setPlayPointInWin(point) {
      let bounds = this.$refs.map.mapAPI.getBounds();
      let aLnglat = [
        [bounds.lng_min, bounds.lat_max],
        [bounds.lng_max, bounds.lat_max],
        [bounds.lng_max, bounds.lat_min],
        [bounds.lng_min, bounds.lat_min]
      ];
      let isIn = this.$refs.map.mapAPI.isPointInRing(point, aLnglat);
      if (!isIn) {
        this.$refs.map.mapAPI.setCenter(point);
      }
    },
    // 保存轨迹  层是 物流地图map组件中写好的，这边只是调用
    async saveLineClick() {
      let bposition = "";
      let eposition = "";
      await api
        .fetchPositionByLonLat({
          lon: this.trackListData[0].lon,
          lat: this.trackListData[0].lat
        })
        .then(res => {
          if (res.code == 1) {
            bposition = res.result;
          }
        });
      await api
        .fetchPositionByLonLat({
          lon: this.trackListData[this.trackListData.length - 1].lon,
          lat: this.trackListData[this.trackListData.length - 1].lat
        })
        .then(res => {
          if (res.code == 1) {
            eposition = res.result;
          }
        });
      let pointArr = this.trackListData.map(m => {
        return {
          lng84: m.lon,
          lat84: m.lat
        };
      });
      let opts = {
        odometer: this.odometer_all,
        bposition: bposition,
        eposition: eposition,
        llObjArr: pointArr
      };
      this.$refs.map.lOpenLayer(opts);
    },
    // 导出轨迹
    exportLineClick() {
      if (this.vehicle_sel == "") {
        this.$message({
          showClose: true,
          message: "请选择车辆",
          type: "warning"
        });
      } else {
        this.$message({
          showClose: true,
          message: "正在导出",
          type: "success"
        });
        api.exportTrackList({
          vehicleId: this.vehicle_sel,
          startTime: this.startTime,
          endTime: this.endTime,
          distance: this.distanceSel * 1000,
          second: this.timeSel,
          stopSecond: this.searchStop
        });
      }
    },
    // 清除轨迹
    clearLineClick() {
      this.clearAllOverlay("clear");
      this.clearVaribles();
    },

    // 请求 温度 数据
    async fetchTemperatureList() {
      this.temperatureNoData = true;
      api
        .fetchTemperatureNumData({
          vehicleId: this.vehicle_sel,
          startTime: this.startTime,
          endTime: this.endTime
        })
        .then(res => {
          if (res.code == 1 && res.result && res.result.tempData) {
            this.temperatureData = res.result.tempData;
            this.initTempChart();
          } else {
            this.warnMessage("暂无温度曲线数据");
          }
        });
    },
    // 处理温度、湿度数据
    handleChartsData(data) {
      let T = data || [];
      T = T.map(t => {
        return {
          name: t.gpsTime,
          value: [t.gpsTime, t.temperatureNum]
        };
      });
      return T;
    },
    // 初始化温度曲线
    initTempChart() {
      if (
        !(
          this.temperatureData[1] ||
          this.temperatureData[2] ||
          this.temperatureData[3] ||
          this.temperatureData[4] ||
          this.temperatureData[5] ||
          this.temperatureData[6] ||
          this.temperatureData[7] ||
          this.temperatureData[8] ||
          this.temperatureData[9] ||
          this.temperatureData[10] ||
          this.temperatureData[11] ||
          this.temperatureData[12] ||
          this.temperatureData[13] ||
          this.temperatureData[14] ||
          this.temperatureData[15] ||
          this.temperatureData[16]
        )
      ) {
        this.temperatureNoData = true;
        this.warnMessage("暂无温度曲线数据");
        return;
      }
      this.temperatureNoData = false;
      let data = [];
      for (let temp in this.temperatureData) {
        this.temperatureData[temp].length > 0 &&
          data.push({
            name: "温度" + temp,
            type: "line",
            showSymbol: false,
            connectNulls: true,
            symbolSize: 10,
            hoverAnimation: false,
            data: this.handleChartsData(this.temperatureData[temp])
          });
      }
      let option = {
        grid: {
          left: 40,
          top: 20,
          right: 20,
          bottom: 40
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#283b56"
            }
          },
          formatter: function(params) {
            let date = moment(params[0].name);
            let temp = "";
            params.forEach(p => {
              temp +=
                "<br/><span style='color:" +
                p.color +
                "'>" +
                p.seriesName +
                ": " +
                p.value[1] +
                "℃</span>";
            });
            return (
              "<span style='color:#444;'>" +
              date.format("YYYY-MM-DD HH:mm:ss") +
              "</span>" +
              temp
            );
          },
          backgroundColor: "#fff",
          borderWidth: 1,
          extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);",
          textStyle: {
            fontSize: 12
          }
        },
        xAxis: {
          type: "time",
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          }
        },
        series: data
      };
      let tempChart = ECharts.init(this.$refs.temperatureChartDOM);
      tempChart.setOption(option);
      this.tempChart = tempChart;
    },
    // 请求 湿度 数据
    async fetchHumidityList() {
      this.humidityNoData = true;
      api
        .fetchHumidityNumData({
          vehicleId: this.vehicle_sel,
          startTime: this.startTime,
          endTime: this.endTime
        })
        .then(res => {
          if (res.code == 1 && res.result && res.result.humData) {
            this.humidityData = res.result.humData;
            this.initHumidityChart();
          } else {
            this.warnMessage("暂无湿度曲线数据");
          }
        });
    },
    // 初始化湿度曲线
    initHumidityChart() {
      if (
        !(
          this.humidityData[1] ||
          this.humidityData[2] ||
          this.humidityData[3] ||
          this.humidityData[4] ||
          this.humidityData[5] ||
          this.humidityData[6] ||
          this.humidityData[7] ||
          this.humidityData[8] ||
          this.humidityData[9] ||
          this.humidityData[10] ||
          this.humidityData[11] ||
          this.humidityData[12] ||
          this.humidityData[13] ||
          this.humidityData[14] ||
          this.humidityData[15] ||
          this.humidityData[16]
        )
      ) {
        this.humidityNoData = true;
        this.warnMessage("暂无湿度曲线数据");
        return;
      }
      this.humidityNoData = false;
      let data = [];
      for (let temp in this.humidityData) {
        this.humidityData[temp].length > 0 &&
          data.push({
            name: "湿度" + temp,
            type: "line",
            showSymbol: false,
            connectNulls: true,
            symbolSize: 10,
            hoverAnimation: false,
            data: this.handleChartsData(this.humidityData[temp])
          });
      }
      let option = {
        grid: {
          left: 40,
          top: 20,
          right: 20,
          bottom: 40
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#283b56"
            }
          },
          formatter: function(params) {
            let date = moment(params[0].name);
            let temp = "";
            params.forEach(p => {
              temp +=
                "<br/><span style='color:" +
                p.color +
                "'>" +
                p.seriesName +
                ": " +
                p.value[1] +
                "%RH</span>";
            });
            return (
              "<span style='color:#444;'>" +
              date.format("YYYY-MM-DD HH:mm:ss") +
              "</span>" +
              temp
            );
          },
          backgroundColor: "#fff",
          borderWidth: 1,
          extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);",
          textStyle: {
            fontSize: 12
          }
        },
        xAxis: {
          type: "time",
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          }
        },
        series: data
      };
      let humidityChart = ECharts.init(this.$refs.humidityChartDOM);
      humidityChart.setOption(option);
      this.humidityChart = humidityChart;
    },
    chartsResize() {
      this.$nextTick(() => {
        this.tempChart && this.tempChart.resize();
        this.humidityChart && this.humidityChart.resize();
      });
    },
    hideMarkerEvent(show) {
      this.hideMarker("map", show);
    }
  },
  beforeDestroy() {
    clearTimeout(this.playTimeOut);
  }
};
</script>

<style lang="scss" scoped>
$--font-color: #444;
.el-table {
  margin-top: 0 !important;
}

/deep/ .has-gutter {
  th.gutter {
    display: none;
  }
}

.el-table .el-table__header thead tr,
.el-table thead th {
  background-color: #e2e8f0 !important;
}

.el-table td,
.el-table th {
  padding: 5px 0 !important;
}

.el-table .cell {
  line-height: inherit !important;
}

.el-table thead,
.el-table th {
  color: $--font-color !important;
}

.el-table .caret-wrapper {
  height: 20px;
}

.chartNoData {
  background: url("~@/assets/images/pg-nodata.png") center center no-repeat;
}
</style>
